import { render, staticRenderFns } from "./modal-offer-lobby-2.vue?vue&type=template&id=71b578cc"
import script from "./modal-offer-lobby-2.vue?vue&type=script&lang=js"
export * from "./modal-offer-lobby-2.vue?vue&type=script&lang=js"
import style0 from "./modal-offer-lobby-2.vue?vue&type=style&index=0&id=71b578cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports